import type { ReactNode } from 'react';
import { isPortalNotFound } from '../api/config';
import { useProgramConfig } from '../hooks/useProgramConfig';
import NotFoundPage from '../pages/NotFoundPage';
import PortalUnavailablePage from '../pages/PortalUnavailablePage';

// Loads the portal config once, above every route. Pages render only after it has loaded, so no page
// mounts the config query in an error state: React Query would refetch it on mount and the router
// above would go back to loading, an endless spinner (ESCIQ-211).
export default function ProgramConfigGate({ children }: { children: ReactNode }) {
  const { data, error, isFetching, refetch } = useProgramConfig();

  if (error) {
    if (isPortalNotFound(error)) {
      return <NotFoundPage />;
    }
    // Anything else (network error, 5xx, a WAF 403 or 429) is shown as an outage, so it does not look
    // like a dead link.
    return isFetching ? null : <PortalUnavailablePage onRetry={() => void refetch()} />;
  }

  if (!data) {
    return null;
  }

  return <>{children}</>;
}
